import React from 'react';
import loaderIcon from '../../../static/img/loading.svg';

export const LoaderIcon = (props) => <img src={loaderIcon} alt="Trwa ładowanie danych..." />;
